import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import { Button } from '../components/ui/button';
import { Check, Zap } from 'lucide-react';
import { toast } from 'sonner';

export default function Plans() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const handleUpgrade = () => {
    navigate('/checkout/premium');
  };

  return (
    <div className="flex min-h-screen bg-zinc-950" data-testid="plans-page">
      <Sidebar />
      
      <main className="flex-1 md:ml-64 p-4 md:p-6 lg:p-8">
        <div className="mb-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-white mb-2">Planos</h1>
          <p className="text-slate-400">Gerencie sua assinatura</p>
        </div>

        {/* Current Plan Status */}
        <div className="bg-violet-600/10 border border-violet-500/30 rounded-xl p-6 mb-8">
          <h3 className="text-lg font-bold text-violet-400 mb-2">Status Atual</h3>
          <p className="text-white">
            Plano: <span className="font-bold">{user.subscription_status === 'trial' ? 'Teste Grátis' : 'Premium'}</span>
          </p>
          {user.subscription_status === 'trial' && user.trial_end && (
            <p className="text-sm text-slate-300 mt-2">
              Seu teste grátis termina em: {new Date(user.trial_end).toLocaleDateString('pt-BR')}
            </p>
          )}
        </div>

        {/* Pricing */}
        <div className="max-w-md mx-auto">
          <div className="relative bg-zinc-900 border border-violet-500 rounded-2xl p-8 shadow-xl">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
              <span className="bg-violet-600 text-white px-4 py-1 rounded-full text-sm font-bold">PLANO PREMIUM</span>
            </div>
            <h3 className="text-2xl font-bold text-white mb-4">Acesso Completo</h3>
            <div className="flex items-baseline mb-6">
              <span className="text-5xl font-bold text-white">R$19,90</span>
              <span className="text-slate-400 ml-2">/mês</span>
            </div>
            <ul className="space-y-4 mb-8">
              <li className="flex items-start text-slate-300">
                <Check className="w-5 h-5 text-violet-600 mr-3 mt-0.5 flex-shrink-0" />
                <span>Clientes ilimitados</span>
              </li>
              <li className="flex items-start text-slate-300">
                <Check className="w-5 h-5 text-violet-600 mr-3 mt-0.5 flex-shrink-0" />
                <span>Múltiplas instâncias WhatsApp</span>
              </li>
              <li className="flex items-start text-slate-300">
                <Check className="w-5 h-5 text-violet-600 mr-3 mt-0.5 flex-shrink-0" />
                <span>Integração Telegram</span>
              </li>
              <li className="flex items-start text-slate-300">
                <Check className="w-5 h-5 text-violet-600 mr-3 mt-0.5 flex-shrink-0" />
                <span>Cobranças automáticas</span>
              </li>
              <li className="flex items-start text-slate-300">
                <Check className="w-5 h-5 text-violet-600 mr-3 mt-0.5 flex-shrink-0" />
                <span>Suporte prioritário</span>
              </li>
            </ul>
            {user.subscription_status === 'trial' && (
              <Button 
                onClick={handleUpgrade} 
                className="w-full bg-violet-600 hover:bg-violet-700 text-white font-medium shadow-lg shadow-violet-500/20 transition-all hover:-translate-y-0.5 h-12 rounded-md"
                data-testid="upgrade-btn"
              >
                <Zap className="w-4 h-4 mr-2" />
                Assinar Agora
              </Button>
            )}
            {user.subscription_status === 'active' && (
              <div className="text-center">
                <p className="text-emerald-400 font-bold">Você já é Premium! ✨</p>
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
}
